// Display only values present in the proposal; the Core remains authoritative
// for validating and saving the original structured payload.
export function offerProposalDisplay(raw: string): string {
  try {
    const value: unknown = JSON.parse(raw);
    if (!value || typeof value !== "object" || !("name" in value) || typeof value.name !== "string" || !value.name.trim()) return raw;
    const item = value as Record<string, unknown>;
    const details = [value.name.trim()];
    if (typeof item.description === "string" && item.description.trim()) details.push(item.description.trim());
    if (typeof item.priceCents === "number" && Number.isInteger(item.priceCents) && item.priceCents >= 0) details.push(`Valor informado para revisão: ${(item.priceCents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}`);
    if (typeof item.conditions === "string" && item.conditions.trim()) details.push(`Condições: ${item.conditions.trim()}`);
    return details.join(" · ");
  } catch { return raw; }
}
